export const FIREBASE_APP_INSTANCES_NAMES = 'firebase-app-instances-names';

export const USER_COOKIE_CONSENT = 'user-cookie-consent';

export const EMAIL_FOR_SIGN_IN = 'emailForSignIn';

export const DEFAULT_INSTANCE_COMPANY_ID = 'DEFAULT_INSTANCE_COMPANY_ID';

export const SAML_LOGIN_COMPANY_ID = 'SAML_LOGIN_COMPANY_ID';
